export const CSS_EDITING_SCOPE_CLASS = 'css-editing-scope';
//# sourceMappingURL=constants.js.map